import React from 'react'
import PropTypes from 'prop-types'
import { format, toDate } from 'date-fns'
import { useHistory } from 'react-router-dom'

import { useCommonStyles } from '../../../modules/shared/subscription-common.styles'
import { signupImage } from '../../../modules/shared/subscription-constants'
import { usePlanChangeFlag } from '../../../hooks/usePlanChange'
import { ACCOUNT_SCREENS } from '../../../constants'
import ModalContainer from '../../modal-container'
import Button from '../../button'
import PlanDetails from '../../plan-details'
import VoucherMessages from '../../voucher-messages'
import styles from '../cancel-subscription.css'

function VoucherConfirmationModal({ subscriptionAfterRedeem }) {
  const history = useHistory()
  const commonStyles = useCommonStyles()
  const {
    basic,
    standard,
    annual,
    legacy
  } = usePlanChangeFlag()

  const voucher = subscriptionAfterRedeem.recurringVouchers?.[0]
  const orderDetails = voucher?.orderDetails

  const chargedPrice = orderDetails?.chargedPrice
  const sku = orderDetails?.sku
  const nextPaymentDate = orderDetails?.nextPaymentDate

  const nextPaymentDateFormatted = nextPaymentDate
    ? format(toDate(parseInt(nextPaymentDate, 10)), 'd MMM yyyy')
    : null

  const subscriptions = [basic, standard, annual, legacy]

  const subscriptionStaticDetail = subscriptions.find(sub => sub?.sku === sku)?.staticDetail || {
    name: null,
    value: null
  }

  const details = [
    {
      name: `${subscriptionStaticDetail.name}`,
      value: `${subscriptionStaticDetail.value}`
    },
    {
      name: 'Payment due',
      value: `${nextPaymentDateFormatted}`
    },
    {
      name: 'Payment',
      value: `$${chargedPrice}`
    }
  ]

  const onClickHandler = () => {
    history.replace(ACCOUNT_SCREENS.SUBSCRIPTION_PAYMENT.path)
  }

  return (
    <ModalContainer
      darkTheme
      onRequestClose={onClickHandler}
    >
      <div className={styles.confirmationModalWrapper}>
        <div className={styles.header}>Your voucher is good to go!</div>
        {details && <PlanDetails detail={details} showVoucherMessage />}
        <VoucherMessages />
        <img
          src={signupImage}
          alt="Plan confirmation"
          className={commonStyles.image}
        />
        <Button className={styles.button} text="Get started!" onClick={onClickHandler} />
      </div>
    </ModalContainer>
  )
}

VoucherConfirmationModal.propTypes = {
  subscriptionAfterRedeem: PropTypes.oneOfType([PropTypes.object]).isRequired
}

export default VoucherConfirmationModal
